import React, {useEffect} from 'react';
import {useGTMConsent} from '@hooks/useGTMConsent';

declare global {
	interface Window {
		dataLayer: any[];
		gtag: (...args: any[]) => void;
	}
}

interface GTMManagerProps {
	children?: React.ReactNode;
}

const GTMManager: React.FC<GTMManagerProps> = ({children}) => {
	const {hasConsent, hasAnalytics, hasMarketing, isLoading} = useGTMConsent();

	// manage consent changes
	useEffect(() => {
		if (isLoading || typeof window === 'undefined' || !window.gtag) return;

		// send consent data to GTM
		window.gtag?.('consent', 'update', {
			analytics_storage: hasAnalytics ? 'granted' : 'denied',
			ad_storage: hasMarketing ? 'granted' : 'denied',
			functionality_storage: hasConsent ? 'granted' : 'denied',
			personalization_storage: hasMarketing ? 'granted' : 'denied',
			security_storage: 'granted',
		});

		// personalize event to know that consent has changed
		window.gtag?.('event', 'consent_update', {
			has_analytics_consent: hasAnalytics,
			has_marketing_consent: hasMarketing,
			has_general_consent: hasConsent,
		});

		// validation test
		if (process.env.NODE_ENV === 'development') {
			// eslint-disable-next-line no-console
			console.log('🔍 GTM Manager State:', {
				isLoading,
				hasConsent,
				hasAnalytics,
				hasMarketing,
				timestamp: new Date().toISOString(),
			});
		}
	}, [hasAnalytics, hasMarketing, hasConsent, isLoading]);

	return <>{children}</>;
};

export default GTMManager;
